import { Greyscale, SecondaryColor } from 'glints-aries';
import styled from 'styled-components';

import UnstyledButton from 'src/components/Button/UnstyledButton';

export const PaginationContainer = styled.div`
  display: flex;
  width: auto;
  align-items: center;
`;

export const Dots = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${Greyscale.grey};
  width: 38px;
  height: 40px;
`;

const size = `
  width: 38px;
  height: 40px;
`;

export const Arrow = styled(UnstyledButton)`
  ${size}
  cursor: pointer;
`;

export const Number = styled(UnstyledButton)<{ isActive: boolean }>`
  ${size}
  border-radius: 4px;
  background-color: ${({ isActive }) =>
    isActive ? SecondaryColor.actionblue : 'none'};
  color: ${({ isActive }) => (isActive ? Greyscale.white : Greyscale.grey)};
  font-weight: 500;
  &:hover {
    color: ${({ isActive }) =>
      isActive ? Greyscale.white : SecondaryColor.actionblue};
  }
`;
